<ui-modal size="lg" [header]="false">
	<ng-container *ngIf="details">
		<div class="text-small">
			<div class="d-flex mb-1">
				<div class="flex-weight-1 mr-1">
					<h1 class="m-0">{{details.name}}</h1>
				</div>
				<div>
					<button *ngIf="mode !== 'book' && details.work_order_id && details.work_order_stage !== 'completed'" type="button" class="btn btn-outline-primary mr-2" (click)="schedule(details)" [disabled]="disabled">Book</button>
					<button *ngIf="canAddToSalesOrder()" type="button" class="btn btn-outline-secondary mr-2" (click)="addToSalesOrder()" ngbTooltip="Add task to Quote/Sales Order">Add to <i class="wq wq-handshake ml-2"></i></button>
					<button *ngIf="details.stage === 'follow_up'" type="button" class="btn btn-outline-success p-2 mr-2" (click)="editFollowUp(details)" ui-modal-footer>Resolve Follow-up</button>
					<button *ngIf="details.stage !== 'follow_up' && details.work_order_no" type="button" class="btn btn-outline-warning p-2 mr-2" (click)="editFollowUp(details)" ui-modal-footer>Mark As Follow-up</button>
					<button *ngIf="details.stage !== 'completed'" type="button" class="btn btn-outline-info btn-sm p-2 mr-2" (click)="addSubTask(details)" ui-modal-footer><i class="wq wq-add mr-2"></i>Add New Subtask</button>
					<button type="button" class="btn btn-outline-secondary btn-sm border-0 px-1 mr-2" (click)="editTask(details)" ui-modal-footer><i class="wq wq-edit mr-2"></i>Edit</button>
					<button type="button" class="btn btn-outline-secondary btn-sm border-0 px-1" (click)="modal.close()" ui-modal-footer><i class="wq wq-close"></i></button>
				</div>
			</div>
			<div class="mb-3 text-large">
				{{details.customer_name}}
				<ng-container *ngIf="details.project">
					<span class="text-secondary">/</span>
					<a class="text-info text-bold selectable" ngbTooltip="Go to the Project" target="_blank" [routerLink]="['/', app.org, 'project', details.project_id]" (click)="$event.stopPropagation()">{{details.project}}</a>
				</ng-container>
			</div>

			<div class="d-flex align-items-start">
				<div class="mr-4"><span class="text-secondary">Created On</span>
					<div class="mt-2">
						<i *ngIf="!details.created_from_snagg" class="wq wq-device-desktop" ngbTooltip="Created On PC"></i>
						<i *ngIf="details.created_from_snagg" class="wq wq-device-mobile" ngbTooltip="Created On Mobile"></i>
						{{details.created_datetime | mySQLDateToISO | localizedDate:'shortDate'}}
					</div>
				</div>

				<div class="mr-4"><span class="text-secondary">Created by</span>
					<div class="mt-2">
						<ui-user-image *ngIf="details.created_user_email" size="1.5rem" [email]="details.created_user_email" [title]="details.created_user_name"></ui-user-image>
						{{details.created_user_name}}
					</div>
				</div>

				<div class="mr-4"><span class="text-secondary">Last Activity</span>
					<div class="mt-2">
						<ng-container *ngIf="details.last_clocked_in_datetime; else noActivity">
							{{details.last_day_of_week}} {{details.last_clocked_in_datetime | mySQLDateToISO | localizedDate: 'shortDate'}}<br>
							<small class="text-secondary">{{details.activity_text}}</small>
						</ng-container>
						<ng-template #noActivity>
							<div class="text-muted mt-2 text-center">-</div>
						</ng-template>
					</div>
				</div>

				<div class="mr-5"><span class="text-secondary">Next Booking</span>
					<div *ngIf="details.next_allocation_start_date; else noAllocation" class="d-flex align-items-center mt-2">
						<div>
							{{details.next_day_of_week}} {{details.next_allocation_start_date | mySQLDateToISO | localizedDate:'shortDate'}}<br>
							<small class="text-secondary">{{details.next_allocation_text}}</small>
						</div>
					</div>
					<ng-template #noAllocation>
						<div class="text-muted mt-2 text-center">-</div>
					</ng-template>
				</div>

				<div class="mr-5"><span class="text-secondary">Status</span>
					<div>
						<div *ngIf="details.billable" class="badge badge-info mt-2">Billable</div>
						<div *ngIf="!details.billable" class="badge badge-secondary mt-2">Not Billable</div>
					</div>
					<div class="d-flex align-items-center mt-1">
						<div class="badge badge-{{service.stageColor(details.stage)}}"> {{service.stageDescription(details.stage)}}</div>
						<div *ngIf="details.stage === 'completed'" class="text-small text-success text-bold ml-1 mt-1">{{details.completed_datetime | mySQLDateToISO | localizedDate:'shortDate'}}</div>
					</div>
				</div>

				<div class="mr-5">
					<div class="text-secondary mb-1">Priority</div>
					<ui-task-priority [priority]="details.priority"></ui-task-priority>
				</div>

				<div class="mr-5 text-large" *ngIf="details.area || details.category || details.labour_types">
					<div *ngIf="details.area && details.area.length > 1">
						<span class="badge badge-lightgrey text-no-transform text-normal mr-1 mt-1">{{details.area.length}} Areas</span>
					</div>
					<div *ngIf="details.category && details.category.length > 1">
						<span class="badge badge-lightgrey text-no-transform text-normal mr-1 mt-1">{{details.category.length}} Systems</span>
					</div>
					<div *ngIf="details.labour_types && details.labour_types.length > 1">
						<span class="badge badge-light border border-lightgrey text-no-transform text-normal mr-1 mt-1">{{details.labour_types.length}} Labour Types</span>
					</div>
					<div *ngIf="details.area && details.area.length === 1">
						<span class="badge badge-lightgrey text-no-transform text-normal mr-1 mt-1">{{details.area}}</span>
					</div>
					<div *ngIf="details.category && details.category.length === 1">
						<span class="badge badge-lightgrey text-no-transform text-normal mr-1 mt-1">{{details.category}}</span>
					</div>
					<div *ngIf="details.labour_types && details.labour_types.length === 1">
						<span class="badge badge-light border border-lightgrey text-no-transform text-normal mr-1 mt-1">{{details.labour_types}}</span>
					</div>
				</div>
				<div *ngIf="details.stock_variation && details.stock_variation.length">
					<div class="border rounded px-3 py-2 d-block d-flex align-items-center" [ngbTooltip]="details.stock_variation ? details.stock_variation : null">
						<i class="mr-2 wq wq-warning " [ngClass]="{'text-warning': details.stock_variation && details.stock_variation.length , 'text-secondary': !details.stock_variation}" style="font-size: 1.5rem;"></i>
						<span>Stock Variation</span>
					</div>
				</div>
			</div>

			<div *ngIf="assignedToUsers().length" class="mb-3">
				<div class="text-secondary mb-2">Assigned To</div>
				<div class="d-flex align-items-center mr-2">
					<ng-container *ngFor="let user of assignedToUsers(); let i = index">
						<ui-user-image class="mr-1" size="1.5rem" [email]="user.email" [title]="user.title" style="margin-left: -5px;"></ui-user-image>
					</ng-container>
					<span [innerHTML]="assignedToNames()" class="text-secondary"></span>
				</div>
			</div>
			<div class="mb-3">
				<ui-task-progress-bar [item]="details"></ui-task-progress-bar>
			</div>

			<div class="mb-3">
				<a *ngIf="details.work_order_no" target="_blank" style="color: #000;" [routerLink]="['/', app.org, 'job', details.work_order_id]" class="mr-2" ngbTooltip="Go to the Job">Job {{details.work_order_no}} {{details.work_order_name}}</a>
				<a *ngIf="details.quote_id" style="color: #000;" target="_blank" [routerLink]="['/', app.org, 'quote', details.quote_id]" class="mr-2" ngbTooltip="Go to the Quote">Accepted Quote #{{details.quote_no}}</a>
			</div>

			<div *ngIf="details.combined_quotes" class="mb-3">
				<h6 class="mb-1">Sales Order / Quote</h6>
				<a *ngFor="let quote of details.combined_quotes" target="_blank" style="color: #000;" [routerLink]="['/', app.org, 'quote', quote.quote_id]" class="text-secondary mr-2" ngbTooltip="Go to Quote/Sales Order" (click)="$event.stopPropagation();">{{quote.quote_no}}</a>
			</div>

			<div *ngIf="details.description && details.description.length" class="mb-3">
				<h6 class="mb-1">Description</h6>
				<div class="text-secondary text-pre" [innerHTML]="details.description | linky" style="max-height: 100px; overflow: auto;"></div>
			</div>
			<div *ngIf="details.dependencies.length" class="d-flex mb-3">
				<div [ngClass]="{ 'selectable hoverable': hasCompletedDependencies() }" (click)="showDependencies = !showDependencies">
					<h6 class="mb-1">Dependencies <i *ngIf="hasCompletedDependencies()" class="wq wq-caret-{{showDependencies ? 'down' : 'right'}} text-large"></i></h6>
					<div *ngFor="let d of details.dependencies">
						<i class="wq wq-dependency-{{d.type}} mr-1 text-large {{d.done ? 'text-primary' : 'text-silver'}}"></i>
						<span class="text-secondary">{{d.name}}</span>
					</div>
				</div>
				<button *ngIf="!hasCompletedDependencies()" class="btn btn-outline-secondary border-0 mx-2 h-20 text-uppercase" (click)="addDependency(details)"><i class="wq wq-add mr-1"></i>Add</button>
				<div class="flex-weight-1 scrollable px-3">
					<div *ngIf="showDependencies" class="d-flex align-items-center">
						<div *ngFor="let d of details.dependencies | manglerFilter:{done:1}" class="p-1 rounded selectable hoverable" (click)="openDependency(d)">
							<div *ngIf="d.image_url" class="w-8r h-8r mb-2 border border-8 border-lightgrey rounded product-image image-container" style="background-size: cover;" [style.backgroundImage]="'url(\'' + d.image_url + '\')' | safeStyle">
								<div class="dependency-count badge-light p-1" *ngIf="d.image_data?.image_id.length > 1">
									<i class="wq wq-camera mr-1"></i>
									{{d.image_data.image_id.length}}
								</div>
							</div>

							<div *ngIf="!d.image_url" style="word-break: break-word;" class="w-8r h-8r mb-2 border border-8 border-lightgrey rounded p-2 text-pre text-small overflow-hidden bg-white">{{d.text_content}}</div>
							<div class="text-small w-8r">
								<div class="text-lines lines-1" uiEllipsisTooltip><i class="wq wq-dependency-{{d.type}} mr-1 text-large text-primary"></i> <span class="text-secondary">{{d.name}}</span></div>
								<div class="text-lines lines-1 text-bold" uiEllipsisTooltip>{{d.user_name}}</div>
								<div class="text-lines lines-1 text-tiny text-secondary" uiEllipsisTooltip>{{d.completed_datetime | mySQLDateToISO | localizedDate:'shortDate'}} {{d.completed_datetime | mySQLDateToISO | localizedDate:'shortTime'}}</div>
							</div>
						</div>
						<button *ngIf="hasCompletedDependencies()" class="btn btn-outline-secondary border-0 mx-2 text-uppercase" (click)="addDependency(details)">Add / Edit</button>
					</div>
				</div>
			</div>

			<div *ngIf="details?.items && details?.items?.length">
				<div class="text-bold selectable" (click)="service.toggleTaskItemExpanded(details.id); $event.stopPropagation();">
					{{details.items.length}} {{details.items.length === 1 ? 'Item': 'Items'}}
					<i class="wq" [ngClass]="{'wq-caret-up': !service.isTaskItemExpanded(details.id), 'wq-caret-down': service.isTaskItemExpanded(details.id)}"></i>
				</div>

				<div class="py-2" *ngIf="service.isTaskItemExpanded(details.id)" style="max-height: 300px; overflow: auto;" (click)="$event.stopPropagation();">
					<div>
						<table class="table table-hover vam">
							<tbody>
								<tr *ngFor="let item of details.items">
									<td class="shrink px-0">
										<div *ngIf="item.css_background" class="product-image mr-3" [style.backgroundImage]="item.css_background | safeStyle"></div>
									</td>
									<td class="pl-0">
										<div class="text-bold">{{item.short_description}}</div>
										<div *ngIf="item.manufacturer_name || item.model" class="text-secondary">{{item.manufacturer_name}} {{item.manufacturer_name && item.model ? '/' : ''}} {{item.model}}</div>
										<div *ngIf="item.sku || item.manufacturer_sku" class="text-secondary text-tiny">{{item.sku || item.manufacturer_sku}}</div>

										<div *ngIf="item.supplied_by_customer" class="text-info"><i class="wq wq-info"></i> Supplied by customer</div>
										<div *ngIf="item.notes" class="text-info"><i class="wq wq-info"></i> {{item.notes}}</div>
										<div>
											<span *ngIf="item.category" class="max-width-7 badge badge-lightgrey text-no-transform text-normal mt-1"><span class="text-lines lines-2" uiEllipsisTooltip>{{item.category}}</span></span>
											<span *ngIf="item.area" class="max-width-7 badge badge-lightgrey text-no-transform text-normal mt-1"><span class="text-lines lines-2" uiEllipsisTooltip>{{item.area}}</span></span>
											<ng-container *ngFor="let lt of item.labour_types">
												<span class="max-width-7 badge badge-light border border-lightgrey text-no-transform text-normal mt-1"><span class="text-lines lines-2" uiEllipsisTooltip>{{lt}}</span></span>
											</ng-container>
										</div>
									</td>
									<td>
										<div *ngIf="item.total_quantity">{{item.total_quantity}} qty</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>

			<div *ngIf="hasEditableSubtasks()" class="d-flex justify-content-end mt-2">
				<button type="button" class="btn btn-outline-secondary btn-sm" (click)="bulkEditSubtasks()"><i class="wq wq-edit mr-2"></i>Bulk Edit</button>
			</div>

			<div style="max-height: 300px; overflow: auto;">
				<ui-subtask-list [item]="details" (notesClicked)="notesClicked($event)" (editSubTask)="editTask($event)" (markFollowUpSubTask)="editFollowUp($event)" (editedSubtaskStage)="editedSubtaskStage($event)" (clickDependency)="openDependency($event)" (addDependency)="addDependencySubtask($event)" [editable]="true"></ui-subtask-list>
			</div>

			<div class="d-flex border-bottom mt-2">
				<div *ngFor="let t of tabs" class="p-2 selectable hoverable flex-weight-1 d-flex align-items-center" [ngClass]="{ 'border-bottom border-primary border-4': tab === t.id, 'border-lightgrey': tab !== t.id }" (click)="changeMode(t.id)">
					<span class="text-uppercase text-small text-bold mr-2" [ngClass]="{ 'text-secondary': tab !== t.id }">{{t.description}}</span>
					<span class="badge" [ngClass]="{ 'badge-primary': tab === t.id, 'badge-secondary': tab !== t.id  }">{{getTabCount(t)}}</span>
				</div>
			</div>

			<ng-container *ngIf="details && tab === 'notes'">
				<div class="row p-3" style="max-height: 220px; overflow: auto;">
					<div class="col-4 mt-2">
						<div (click)="openTaskNotes()" class="d-flex align-items-center justify-content-center border border-1 p-2 h-100 text-secondary selectable hoverable">
							<div class="text-center">
								<div class="text-large">
									<i class="wq wq-add text-secondary text-large"></i>
								</div>
								<div>Add a New Note</div>
							</div>
						</div>
					</div>
					<div class="col-4 mt-2" *ngFor="let note of details.notes; let i = index">
						<div class="d-flex align-items-start border border-1 p-2 h-100 selectable hoverable" (click)="openNote(note)">
							<div class="flex-weight-1 mr-2">
								<div class="d-flex mr-2">
									<ui-user-image [email]="note.user_email"></ui-user-image>
									<div class="flex-weight-1 mx-2">
										<div class="text-bold text-large">{{note.user_name}}</div>
										<div class="text-secondary text-small mb-1">{{note.created_datetime | mySQLDateToISO | localizedDate:'shortDate'}} {{note.created_datetime | mySQLDateToISO | localizedDate:'shortTime'}}</div>
									</div>
								</div>
								<div class="text-large ml-2 mb-1 text-pre"><span class="text-lines lines-2" uiEllipsisTooltip [innerHTML]="note.note | linky"></span></div>
							</div>
							<div *ngIf="note.type === 'resolve_follow_up'" class="bg-success-25 badge text-success mt-2 mr-2">Follow Up Resolved</div>
							<div *ngIf="note.type === 'follow_up'" class="bg-warning-25 badge text-warning mt-2 mr-2">Follow Up</div>
							<button *ngIf="note.editable" class="btn btn-sm btn-outline-medium border-0 p-2" (click)="deleteNote(note); $event.stopPropagation();">
								<i class="wq wq-delete selectable"></i>
							</button>
						</div>
					</div>
				</div>
			</ng-container>

			<ng-container *ngIf="details && tab === 'timeline'">
				<div class="row p-3" style="max-height: 220px; overflow: auto;">
					<div class="col-4 mt-2" *ngIf="app.orgInfo?.role.manage_teams">
						<div (click)="addTimeEntry()" class="d-flex align-items-center justify-content-center border border-1 p-2 h-100 text-secondary selectable hoverable">
							<div class="text-center">
								<div class="text-large">
									<i class="wq wq-add text-secondary text-large"></i>
								</div>
								<div>Add Time Entry</div>
							</div>
						</div>
					</div>
					<div class="col-4 mt-2" *ngFor="let entry of timeEntries">
						<div class="d-flex border border-1 p-2 h-100">
							<div class="flex-weight-1 mr-2">
								<div class="d-flex mr-2 align-items-center">
									<ui-user-image [email]="entry.user_email"></ui-user-image>
									<div class="flex-weight-1 mx-2">
										<div class="text-bold text-large">{{entry.user_name}}</div>
									</div>
								</div>
								<div class="text-secondary text-small mt-1">
									{{entry.start_datetime | mySQLDateToISO | localizedDate:'mediumDate'}}, {{entry.start_datetime | mySQLDateToISO | localizedDate:'shortTime'}}
									-
									{{entry.end_datetime | mySQLDateToISO | localizedDate:'mediumDate'}}, {{entry.end_datetime | mySQLDateToISO | localizedDate:'shortTime'}}
								</div>
							</div>
							<div class="text-right mt-1">
								<div class="d-flex justify-content-end">
									<div class="ml-2">
										<div *ngIf="entry.self_assigned" class="text-primary"> <i class="wq wq-flag mr-1"></i>Self-Assigned</div>
										<ui-timeentry-approval-status *ngIf="entry.approval_status" [approval_status]="entry.approval_status"></ui-timeentry-approval-status>
									</div>
									<div>
										<div *ngIf="entry.type === 'travel'" class="text-info badge bg-info-25 text-bold ml-2"> <i class="wq wq-truck-fill mr-1"></i>Travel</div>
									</div>									
								</div>
								<div>{{entry.hours | hours}}</div>
							</div>
							<button *ngIf="(app.orgInfo?.role.access_timesheets && entry.user_id === app.userId) || app.orgInfo?.role.manage_teams" class="ml-2 h-50 btn btn-sm btn-outline-medium border-0 p-2" (click)="editTime(entry); $event.stopPropagation();">
								<i class="wq wq-edit selectable"></i>
							</button>
						</div>
					</div>
					<p class="mt-2 ml-4 text-small text-secondary" *ngIf="!timeEntries.length && !(app.orgInfo?.role.manage_teams || app.orgInfo?.role.access_timesheets)">No time entries</p>
				</div>
			</ng-container>

			<ng-container *ngIf="details && tab === 'reports'">
				<div class="row p-3" style="max-height: 220px; overflow: auto;">
					<div class="col-4 mt-2">
						<div class="d-flex align-items-center justify-content-center hoverable border border-1 p-2 h-100 text-secondary selectable" (click)="editReport()">
							<div class="text-center">
								<div class="text-large">
									<i class="wq wq-add text-secondary text-large"></i>
								</div>
								<div>Add New Report</div>
							</div>
						</div>
					</div>
					<div class="col-4 mt-2" *ngFor="let entry of reports">
						<div class="d-flex align-items-start border border-1 p-2 h-100 selectable hoverable" (click)="openReport(entry)">
							<div class="flex-weight-1 mr-2">
								<div class="d-flex mr-2">
									<ui-user-image [email]="entry.email_addr"></ui-user-image>
									<div class="flex-weight-1 mx-2">
										<div class="text-bold text-large">{{entry.user_name}}</div>
										<div class="text-secondary text-small mb-1">{{entry.created_datetime | mySQLDateToISO | localizedDate:'shortDate'}} {{entry.created_datetime | mySQLDateToISO | localizedDate:'shortTime'}}</div>
									</div>
								</div>
								<div>{{entry.name}}</div>
							</div>
							<div class="text-right mt-1 mr-2">
								<div *ngIf="entry.task_id" class="bg-success-25 badge text-success">Task Report</div>
							</div>
							<button *ngIf="entry.editable" class="btn btn-sm btn-outline-medium border-0 p-2" (click)="editReport(entry.id); $event.stopPropagation();">
								<i class="wq wq-edit"></i>
							</button>
						</div>
					</div>
				</div>
			</ng-container>

			<ng-container *ngIf="details && tab === 'products' && details.billable">
				<div style="max-height: 220px; overflow: auto;">
					<table class="table table-hover vam mt-2">
						<tbody>
							<tr *ngIf="details.stage !== 'completed'">
								<td colspan="5">
									<div (click)="addProducts()" class="d-flex align-items-center justify-content-center border border-1 p-2 h-100 text-secondary selectable hoverable">
										<div class="text-center">
											<div class="text-large">
												<i class="wq wq-add text-secondary text-large"></i>
											</div>
											<div>Add a Product</div>
										</div>
									</div>
								</td>
							</tr>
							<tr *ngFor="let item of details.materials">
								<td class="shrink px-0">
									<div *ngIf="item.image_url" class="product-image w-2r h-2r my-n1" [style.backgroundImage]="'url(\'' + item.image_url + '\')' | safeStyle"></div>
								</td>
								<td class="pl-0">
									<div class="text-bold">{{item.short_description}}</div>
									<div *ngIf="item.manufacturer_name || item.model" class="text-secondary">{{item.manufacturer_name}} {{item.manufacturer_name && item.model ? '/' : ''}} {{item.model}}</div>
									<div *ngIf="item.sku || item.manufacturer_sku" class="text-secondary text-tiny">{{item.sku || item.manufacturer_sku}}</div>

									<div *ngIf="item.supplied_by_customer" class="text-info"><i class="wq wq-info"></i> Supplied by customer</div>
									<div *ngIf="item.notes" class="text-info"><i class="wq wq-info"></i> {{item.notes}}</div>
								</td>
								<td class="shrink">
									<div *ngIf="item.catalogue_id" class="cat-image border bg-white border-silver rounded-circle shadow-sm" [style.backgroundImage]="'url(\'' + item.catalogue_image_url + '\')' | safeStyle" [ngbTooltip]="item.catalogue_name"></div>
								</td>
								<td class="text-center nowrap py-0" style="width: 10rem; position: relative;">
									<div *ngIf="details.stage !== 'completed'" class="selectable">
										<ng-container *ngIf="quantityEdit !== item.id">
											<button class="btn btn-sm btn-outline-primary border-0 px-1" (click)="increaseLineQuantity(item, 1)"><i class="wq wq-chevron-up"></i></button><br>
											<span (click)="editQuantity(item)">QTY: {{(item.quantity) | decimal:0:4}}</span>
											<br>
											<button class="btn btn-sm btn-outline-primary border-0 px-1" (click)="increaseLineQuantity(item, -1)" [disabled]="item.quantity <= 1"><i class="wq wq-chevron-down"></i></button>
										</ng-container>
										<div *ngIf="quantityEdit === item.id" class="input-group" style="width: 9rem;">
											<input type="text" class="form-control" placeholder="Quantity" [(ngModel)]="quantityEditValue" (keyup.enter)="saveQuantity(item)" autocomplete="chrome-off" appAutoFocus>
											<span class="input-group-append">
												<button class="btn btn-success px-2" (click)="saveQuantity(item)"><i class="wq wq-check"></i></button>
											</span>
											<span class="input-group-append">
												<button class="btn btn-secondary px-2" (click)="cancelQuantity(item)"><i class="wq wq-close"></i></button>
											</span>
										</div>
									</div>
									<ng-container *ngIf="details.stage === 'completed'">
										<span>QTY: {{(item.quantity) | decimal:0:4}}</span>
									</ng-container>
								</td>
								<td class="shrink nowrap text-right" *ngIf="details.stage !== 'completed'">
									<button class="btn btn-sm btn-outline-danger border-0 px-1" (click)="removeProduct(item)"><i class="wq wq-close"></i></button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</ng-container>
		</div>
	</ng-container>
</ui-modal>

<app-modal-edit-task (close)="taskEditModalClosed($event)"></app-modal-edit-task>
<modal-view-dependency></modal-view-dependency>
<modal-activity-log (close)="activityLogClosed()"></modal-activity-log>
<modal-edit-report (close)="editReportModalClosed($event)"></modal-edit-report>
<modal-edit-dependency-outcome (close)="editDependencyOutcomeModalClosed($event)"></modal-edit-dependency-outcome>
<modal-task-notes (close)="activityLogClosed()"></modal-task-notes>
<modal-timesheet-add-entry (close)="timesheetAddModalClosed($event)"></modal-timesheet-add-entry>
<modal-timesheet-edit-conflict (close)="timesheetEditConflictModalClosed($event)"></modal-timesheet-edit-conflict>
<modal-select-product (close)="productSelectModalClosed($event)" [addedProducts]="addedProducts"></modal-select-product>
<modal-edit-task-followup (close)="taskFollowUpModalClosed($event)"></modal-edit-task-followup>
<app-modal-bulk-edit-subtask (close)="bulkEditSubtaskModalClosed($event)"></app-modal-bulk-edit-subtask>
<modal-bulk-edit-task (close)="bulkEditTaskModalClosed($event)"></modal-bulk-edit-task>
